import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PartnerApplicationPage.css';

const PARTNER_FORM_URL =
  'https://frontal-firestorm-840.forms.space/partner-with-office-outing-naiz6q';

const PartnerApplicationPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });

    const existingScript = document.querySelector(
      'script[data-formspace-partner-embed]'
    );

    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');

    script.src = 'https://formspace.com/embed.js';
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.dataset.formspacePartnerEmbed = 'true';

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <main className="partner-application-page">
      <div className="partner-application-container">
        <Link to="/partners" className="partner-application-back">
          ← Back to For Partners
        </Link>

        <section className="partner-application-layout">
          <aside className="partner-application-intro">
            <p className="partner-application-eyebrow">
              Partner With Office Outing
            </p>

            <h1>Let’s build something great together.</h1>

            <p className="partner-application-description">
              Tell us about your experience, group capacity, pricing, and
              partnership preferences. We’ll review your information and
              follow up with next steps.
            </p>

            <div className="partner-commission-note">
              <div
                className="partner-commission-icon"
                aria-hidden="true"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 4h6.2c.53 0 1.04.21 1.41.59l8.8 8.8a2 2 0 0 1 0 2.82l-4.2 4.2a2 2 0 0 1-2.82 0l-8.8-8.8A2 2 0 0 1 4 10.2V4Z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <circle
                    cx="8"
                    cy="8"
                    r="1.25"
                    stroke="currentColor"
                    strokeWidth="1.6"
                  />
                </svg>
              </div>

              <div>
                <h2>Submitting this form is free.</h2>

                <p>
                  There is no upfront cost to apply or be listed. Some
                  partnerships may include a referral commission on completed
                  bookings, with all terms agreed upon in advance.
                </p>
              </div>
            </div>
          </aside>

          <section className="partner-application-form-card">
            <div
              className="partner-application-form-embed"
              data-formspace={PARTNER_FORM_URL}
            />
          </section>
        </section>
      </div>
    </main>
  );
};

export default PartnerApplicationPage;
